import { render, staticRenderFns } from "./NotificationCaster.vue?vue&type=template&id=248802f2&scoped=true"
import script from "./NotificationCaster.vue?vue&type=script&lang=js"
export * from "./NotificationCaster.vue?vue&type=script&lang=js"
import style0 from "./NotificationCaster.vue?vue&type=style&index=0&id=248802f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248802f2",
  null
  
)

export default component.exports